export enum PresenceEnum {
  Presence = 'Presence', NonAttendance = 'NonAttendance', WithNotice = 'WithNotice', NoSchedule = 'NoSchedule', License = 'License', InasistenceWithOutNotice = 'InasistenceWithOutNotice', Void = 'Void'
}
